import { TextField } from '@mui/material';

const Input = ({ ...remaining }) => <TextField margin="normal" fullWidth {...remaining} />;

export default Input;
